let
    trigger = $('.c-menu__trigger'),
    triggerText = trigger.find('.c-menu__trigger-text'),
    body = $('body'),
    panel = $('.c-menu__panel'),
    menuActiveClass = 'js-menu-active',
    itemActiveClass = 'js-active',
    item = $('.c-menu .menu-item'),
    itemTrigger,
    mobile = false;

if (window.innerWidth < 1025) {
    mobile = true;
}


export default {
    init() {
        this.itemTriggerAppend();
        this.event();
        $(window).resize();
    },
    event() {
        body.on('click', (e) => {
            let target = $(e.target);

            if (target.closest('.c-menu__trigger').length) {
                if (body.hasClass(menuActiveClass)) {
                    body.removeClass(menuActiveClass);
                    triggerText.text('menu');

                    if (item.hasClass(itemActiveClass)) {
                        item.removeClass(itemActiveClass);
                    }

                    item.find('a').css('color', '#333');
                } else {
                    body.addClass(menuActiveClass);
                    triggerText.text('close');
                }
            } else if (!target.closest('.c-menu__panel').length) {
                if (body.hasClass(menuActiveClass)) {
                    body.removeClass(menuActiveClass);
                    triggerText.text('menu');

                    if ( item.hasClass(itemActiveClass) ) {
                        item.removeClass(itemActiveClass);
                    }

                    item.find('a').css('color', '#333');
                }
            }
        });

        $(window).on('resize', () => {
            let viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

            panel.outerHeight(viewportHeight + 'px');

            if (window.innerWidth < 1025) {

                if (mobile) {
                    itemTrigger.on('click', this.clickMenuItemClass);
                    item.off('hover', this.hoverMenuItemClass);
                }

                mobile = false;
            } else {
                if (!mobile) {
                    itemTrigger.off('click', this.clickMenuItemClass);
                    item.on('hover', this.hoverMenuItemClass);

                    item.find('a').css('color', '#333');

                    if ( item.hasClass(itemActiveClass) ) {
                        item.removeClass(itemActiveClass);
                    }
                    if ( body.hasClass(menuActiveClass) ) {
                        body.removeClass(menuActiveClass);
                    }
                    
                }

                mobile = true;
            }
        });
    },

    hoverMenuItemClass(e) {
        let currentTarget = $(e.currentTarget),
            siblingLink = currentTarget.siblings().find('a');

        if (currentTarget.hasClass(itemActiveClass)) {
            currentTarget.removeClass(itemActiveClass);
            siblingLink.css('color', '#333');
        } else {
            currentTarget.addClass(itemActiveClass);
            siblingLink.css('color', '#999');
        }
    },

    clickMenuItemClass(e) {
        let currentTargetParent = $(e.currentTarget).closest('.menu-item'),
            link = currentTargetParent.find('a'),
            siblingLink = currentTargetParent.siblings().find('a');

        if (currentTargetParent.hasClass(itemActiveClass)) {
            currentTargetParent.removeClass(itemActiveClass);
            siblingLink.css('color', '#333');
            // link.css('color', '#999');
        } else {
            currentTargetParent.siblings().removeClass(itemActiveClass);
            currentTargetParent.addClass(itemActiveClass);
            siblingLink.css('color', '#999');
            link.css('color', '#333');
        }
    },

    itemTriggerAppend() {
        item.each(function () {
            let _this = $(this);

            if (_this.children('.sub-menu').length) {
                _this.append('<div class="menu-item-trigger">').on('click', this.clickMenuItemClass);
            }
        });

        itemTrigger = $('.menu-item-trigger');
    },
}



// WEBPACK FOOTER //
// ./scripts/components/menu.js